import { useState } from 'react';

function TeamMemberForm({ member, onSave, onCancel, saving }) {
  const [form, setForm] = useState({
    first_name:      member.first_name      ?? '',
    last_name:       member.last_name       ?? '',
    role:            member.role            ?? '',
    email:           member.email           ?? '',
    slack_handle:    member.slack_handle    ?? '',
    jira_name:       member.jira_name       ?? '',
    jira_account_id: member.jira_account_id ?? '',
    start_date:      member.start_date      ?? '',
    active:          member.active          ?? true,
  });

  const set = (key, val) => setForm(f => ({ ...f, [key]: val }));

  const handleSubmit = e => {
    e.preventDefault();
    onSave({
      ...form,
      role:            form.role            || null,
      email:           form.email           || null,
      slack_handle:    form.slack_handle    || null,
      jira_name:       form.jira_name       || null,
      jira_account_id: form.jira_account_id || null,
      start_date:      form.start_date      || null,
    });
  };

  return (
    <div className="cf-overlay" onClick={e => { if (e.target === e.currentTarget) onCancel(); }}>
      <div className="cf-modal">
        <div className="cf-header">
          <h2>Edit Team Member</h2>
          <button className="cf-close" type="button" onClick={onCancel}>✕</button>
        </div>

        <form className="cf-form" onSubmit={handleSubmit}>
          <div className="cf-columns">

            <div className="cf-col">
              <label className="cf-label">First Name <span className="cf-req">*</span></label>
              <input className="cf-input" required value={form.first_name}
                onChange={e => set('first_name', e.target.value)} />

              <label className="cf-label">Last Name <span className="cf-req">*</span></label>
              <input className="cf-input" required value={form.last_name}
                onChange={e => set('last_name', e.target.value)} />

              <label className="cf-label">Role</label>
              <input className="cf-input" value={form.role}
                onChange={e => set('role', e.target.value)}
                placeholder="e.g. Senior Quality Engineer 1" />

              <label className="cf-label">Email</label>
              <input className="cf-input" type="email" value={form.email}
                onChange={e => set('email', e.target.value)} />

              <label className="cf-label">Slack Handle</label>
              <input className="cf-input" value={form.slack_handle}
                onChange={e => set('slack_handle', e.target.value)}
                placeholder="@handle" />
            </div>

            <div className="cf-col">
              <label className="cf-label">Jira Name</label>
              <input className="cf-input" value={form.jira_name}
                onChange={e => set('jira_name', e.target.value)}
                placeholder="Display name as shown in Jira" />

              <label className="cf-label">Jira Account ID</label>
              <input className="cf-input" value={form.jira_account_id}
                onChange={e => set('jira_account_id', e.target.value)} />

              <label className="cf-label">Start Date</label>
              <input className="cf-input" type="date" value={form.start_date}
                onChange={e => set('start_date', e.target.value)} />

              <label className="cf-label">Active</label>
              <label className="cf-section-check" style={{ marginTop: '4px' }}>
                <input type="checkbox" checked={form.active}
                  onChange={e => set('active', e.target.checked)} />
                Active team member
              </label>
            </div>

          </div>

          <div className="cf-actions">
            <button type="button" className="cf-btn-cancel" onClick={onCancel}>Cancel</button>
            <button type="submit" className="cf-btn-save" disabled={saving}>
              {saving ? 'Saving…' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default TeamMemberForm;
